import React from 'react';
import Select from 'react-select';
import dateFormat from 'dateformat';
import Phone, {isValidPhoneNumber} from 'react-phone-number-input';
import rrui from 'react-phone-number-input/rrui.css';
import rpni from 'react-phone-number-input/style.css';
import ReactQuill from 'react-quill';
import AutosizeTextArea from 'react-textarea-autosize'

export function extractValue(field) {
    let values = [];
    if (field instanceof Array && field.length > 0) {
        values = field.map(elem => {
            return elem.value ? elem.value : elem;
        });
    } else if (field instanceof Array && field.length === 0) {
        return field;
    } else {
        if (Number(field)) {
            values.push( field );
        } else if (!field.value || !field instanceof Array) {
            let string = field.split(',');
            string.map((element) => values.push(element));
        } else {
            values.push(field.value);
        }
    }
    return values;
}


export function errorField({disabled, meta: {touched, error, warning}}) {
    return (
        <div>
            { touched && (
                ( error && <span className="error">{ error }</span> )
                ||
                ( warning && <span className="warning">{ warning }</span> )
            )
            }
        </div>
    );
}

export function textField({input, label, placeholder, initialValue, disabled, meta: {touched, error, warning}}) {
    return (
        <div >

            { label && <label>{ label }</label> }
            <div>
                {/*old version that validates everything*/}
                {/*<input { ...input } className={ `form-control${ touched ? !error ? " approved-field" : " error-field" : "" }` } type="text" placeholder={ placeholder || null }*/}
                       {/*value={ initialValue ? initialValue : input.value } disabled={!!disabled}*/}
                {/*/>*/}
                <input { ...input } className={ `form-control${ touched ? (!error ? "" : " error-field") : "" }` } type="text" placeholder={ placeholder || null }
                       value={ initialValue ? initialValue : input.value } disabled={!!disabled}
                />

                { touched &&
                (
                    ( error && <span className="error">{ error }</span> )
                    ||
                    ( warning && <span className="warning">{ warning }</span> )
                )
                }

            </div>
        </div>
    );
}







export const FormTextField = (props) => {
    const xxx = () => {
        alert(1)
    }
    return (
        <input type="text" placeholder="First Name" value={props.value} onChange={xxx} />
    )
}








export function textFieldTwo({input, label, placeholder, initialValue, disabled, meta: {touched, error, warning}}) {
    return (
        <div className="div-wrap">

            { touched && warning && <label>{ warning }</label> }
            <div className="div-wrap">
                <input { ...input } className={ `form-control${ touched ? (!error ? "" : " error-field") : "" }` } type="text" placeholder={ placeholder || null }
                       value={ initialValue ? initialValue : input.value } disabled={!!disabled}
                />

                {/*{ touched &&*/}
                {/*(*/}
                    {/*( error && <span className="error">{ error }</span> )*/}
                    {/*||*/}
                    {/*( warning && <span className="warning">{ warning }</span> )*/}
                {/*)*/}
                {/*}*/}

            </div>
        </div>
    );
}

export function hiddenTextField( { input, label, placeholder, initialValue, disabled, meta: {touched, error, warning} } ) {
    return (
        <div >
            <label>{ label }</label>

            <div>
                {/*old version that validates everything*/}
                {/*<input { ...input } className={ `form-control${ touched ? !error ? " approved-field" : " error-field" : "" }` } type="text" placeholder={ placeholder || null }*/}
                {/*value={ initialValue ? initialValue : input.value } disabled={!!disabled}*/}
                {/*/>*/}
                <input { ...input } className={ `form-control${ touched ? (!error ? "" : " error-field") : "" }` } type="hidden" placeholder={ placeholder || null }
                       value={ initialValue ? initialValue : input.value } disabled={!!disabled}
                />

                { touched &&
                (
                    ( error && <span className="error">{ error }</span> )
                    ||
                    ( warning && <span className="warning">{ warning }</span> )
                )
                }

            </div>
        </div>
    );
}


export function textAreaField({input, label, placeholder, style, meta: {touched, error, warning}}) {
    return (
        <div>
	        { label && <label>{ label }</label> }
            <div>
            <textarea className="form-control" { ...input }
                      placeholder={ placeholder || null }
                      style={ style || null }
            />
                { touched &&
                (
                    ( error && <span className="error">{ error }</span> )
                    ||
                    ( warning && <span className="warning">{ warning }</span> )
                )
                }
            </div>
        </div>
    );
}

export function autoTextAreaField({input, label, placeholder, style, meta: {touched, error, warning}}) {
    return (
        <div>
	        { label && <label>{ label }</label> }
            <div>
            <AutosizeTextArea className="form-control" { ...input }
                      placeholder={ placeholder || null }
                      style={ style || null }
            />
                { touched &&
                (
                    ( error && <span className="error">{ error }</span> )
                    ||
                    ( warning && <span className="warning">{ warning }</span> )
                )
                }
            </div>
        </div>
    );
}

// THIS IS THE ONE BEING USED ON PROFILE and preferences //
export const selectField = ({input, clearable, initialValue, label, placeholder, options, multi, meta: {touched, error, warning}}) => {

    // set initial value and then supercede it with the actual value
    let condition = input.name === 'country_id';
    let value;
    if( condition && Array.isArray( options ) ){
        value = options.find( item => item.value === initialValue );
        if( input.value && isNaN( Number(input.value) ) ){
            value = input.value;
        };
    };

    return (
        <div className={`new-field-box${touched && ( error && " show-error")}`}>
        { label && <label>{ label }</label> }
        { touched && ( error && <div><em>{error}</em></div> ) }

        <Select
            value={ (condition ? value : input.value) || "" }
            placeholder={ placeholder || 'Select...' }
            isMulti={ multi || false }
            closeMenuOnSelect={ !multi }
            onChange={ input.onChange }
            onFocus={ input.onFocus }
            options={ options }
            clearable={ clearable ? clearable : false }
            className="select"
            classNamePrefix="select"
        />
        </div>
    );
};

export function phoneField({input, label, validatePhone, placeholder, disabled, meta: {touched, error, warning}}) {
    return (
        <div>
            <label>{ label }</label>
            <Phone
                className={ `form-control${ touched ? (!error ? "" : " error-field") : "" }` }
                value={ input.value }
                placeholder={ placeholder }
                onChange={ (e) => validatePhone(e) }
                onBlur={ input.onBlur }
                disabled={!!disabled}
            />
            {
                touched &&
                (
                    ( error && <span className="error">{ error }</span> )
                    ||
                    ( warning && <span className="warning">{ warning }</span> )
                )
            }
        </div>
    )
}

export function checkboxField({input, label, placeholder, checked, initialValue, onClick, meta: {touched, error, warning}}) {
    return (
        <div className="form-checkbox">
            <input value={ initialValue ? initialValue : input.value }  { ...input } type="checkbox" onClick={ onClick }

                   placeholder={ placeholder || null }
                   checked={checked}
            />
            { touched &&
            (
                ( error && <span className="error">{ error }</span> )
                ||
                ( warning && <span className="warning">{ warning }</span> )
            )
            }
            <label>{ label }</label>
        </div>
    )
}

export function checkboxFieldNoState({input, label, placeholder, checked, initialValue, onClick, meta: {touched, error, warning}}) {
    return (
        <div className="form-checkbox">
            <input
                value={ input.value }
                { ...input }
                type="checkbox"
                onClick={ onClick }
                placeholder={ placeholder || null }
                checked={input.value}
            />
            { touched &&
            (
                ( error && <span className="error">{ error }</span> )
                ||
                ( warning && <span className="warning">{ warning }</span> )
            )
            }
            <label><i className="fa fa-check" /></label>
        </div>
    )
}

export function radioField({input, labelId, id, label, placeholder, checked, initialValue, onClick, meta: {touched, error, warning}}) {
    return (
        <div className="form-checkbox">
            <input value={ initialValue ? initialValue : input.value } { ...input } type="radio" onClick={ onClick }
                    { ...( id ? { id } : {} ) }
                    { ...( placeholder ? { placeholder } : {} ) }
                    checked={ checked } />
            { touched && (( error && <span className="error">{ error }</span> ) || ( warning && <span className="warning">{ warning }</span> )) }
            <label htmlFor={labelId}>{ label }</label>
        </div>
    )
}

export function radioFieldNoState({input, label, placeholder, checked, meta: {touched, error, warning}}) {

    return (
        <div className="form-radio">
            <div className="form-radio__radio">
	            <input
		            value={ input.value }
		            { ...input }
		            type="radio"
		            placeholder={ placeholder || null }
		            checked={ checked }
	            />
	            { touched &&
	            (
		            ( error && <span className="error">{ error }</span> )
		            ||
		            ( warning && <span className="warning">{ warning }</span> )
	            )
	            }
	            <label> </label>
            </div>
            <div className="form-radio__label">
	            <span className="label--radio">{ label }</span>
            </div>
        </div>
    )
}


export function validate(field) {
    return [(value) => value ? undefined : `${ field } is required.`];
}

export const validateLength = max => value =>
    value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const validatePhoneNumber = () => (value) => {
    const validPhoneNumber = String(isValidPhoneNumber(value));
    return !validPhoneNumber ? "Phone number must be valid" : undefined;
};


export const removeHtmlTags = (str) => {
    return str.replace(/<(?:.|\n)*?>/gm, '');
};

const removeStartingZero = (date) => {
    if (date) {
        return date.length > 1 && date[0] === "0" ? date[1] : date;
    }
    return null;
};

export const handleDates = (start_date, end_date) => {
    let startMonth = dateFormat(start_date, 'mm'),
        startYear = dateFormat(start_date, 'yyyy'),
        endMonth = ( ( end_date === undefined ) || ( end_date === null ) || (end_date === 'Present') ) ? null : dateFormat(end_date, 'mm'),
        endYear = ( ( end_date === undefined ) || ( end_date === null ) || (end_date === 'Present') ) ? null : dateFormat(end_date, 'yyyy');

    startMonth = removeStartingZero(startMonth);
    endMonth = removeStartingZero(endMonth);

    return {startMonth, startYear, endMonth, endYear}
};

export const handleSingleDate = (date) => {

    let day = dateFormat(date, 'dd'),
        month = dateFormat(date, 'mm'),
        year = dateFormat(date, 'yyyy');

    month = removeStartingZero(month);

    return {day, month, year}
};



export function passwordField({input, label, placeholder, initialValue, disabled, meta: {touched, error, warning}}) {
    return (
        <div >
            <label>{ label }</label>
            <div>
                <input { ...input }
                       className={ `form-control ${ touched ? !error ? "approved-field" : "error-field" : "" }`}
                       type="password"
                       placeholder={ placeholder || null }
                       value={ initialValue ? initialValue : input.value }
                       disabled={!!disabled} />

                { touched &&
                (
                    ( error && <span className="error">{ error }</span> )
                    ||
                    ( warning && <span className="warning">{ warning }</span> )
                )
                }
            </div>
        </div>
    );
}

export const quill = ({input, label, placeholder, style, initialValue, meta: {touched, error, warning}}) => {

  return (
    <div>
      <ReactQuill theme="snow"
                  { ...input }
                  placeholder={ placeholder && `${ placeholder } NB ensure you write http():// before any hyperlinks eg https://www.google.com.` }
                  style={ style || null }
                  onBlur={ () => input.onBlur}
      />
      { touched &&
      (
        ( error && <span className="error">{ error }</span> )
        ||
        ( warning && <span className="warning">{ warning }</span> )
      )
      }
    </div>
  );
};



// WEBPACK FOOTER //
// src/client/helpers/formFieldHelpers.js